import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';
import digestMessage from 'hooks/eventCollector/hash';

export const EMAIL_REGEXP = /^[\w-]([.\w-])*@([\w-]+)\.+[A-Za-z]{2,6}$/;

export interface ITextInputEvent extends IBaseEvent {
  type: 'input';
  isEmail: boolean;
  toJSON(): BaseGetEvent & {
    type: ITextInputEvent['type'];
    value: string | number;
  };
  getHash(): Promise<string>;
}

export default class TextInputEvent
  extends BaseEvent
  implements ITextInputEvent
{
  type = 'input' as const;

  private value: string | number;
  private inputPlaceholder: string | undefined;

  constructor({
    description,
    inputPlaceholder,
    value,
  }: {
    description?: string | undefined;
    inputPlaceholder?: string | undefined;
    value: string | number;
  }) {
    super(description);
    this.value = value;
    this.inputPlaceholder = inputPlaceholder;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      value: this.value,
      inputPlaceholder: this.inputPlaceholder,
    };
  }

  get isEmail() {
    if (typeof this.value === 'number') return false;
    return EMAIL_REGEXP.test(this.value);
  }

  async getHash() {
    return digestMessage(this.value as string);
  }
}
